<template>
  <div id="content container-fluid" v-if="content" v-bind:class="[(background == 'dark' )? 'background-dark':'background-light']">
    <div v-if="titleType == 'scroll'" class="row title-row" v-bind:style='"background:" + color'>
        <div class="title-left title d-flex flex-row-reverse">
            <h1 class="d-flex align-self-center">{{title}}</h1>
            <!--<p class="author">Author</p>-->
        </div>
        <div class="title-right title d-flex flex-row-reverse">
            <img v-if="titleImg" class="d-flex title-img" v-bind:src="require('@/assets/'+ titleImg)">
        </div>
    </div>
    <div v-if="titleType == 'network'" class="network-title-row" >
        <div class="d-flex network-title justify-content-center" v-bind:style='"border-bottom: 5px solid " + color'>
            <h1 v-bind:style='"color: " + color'>{{title}}</h1>
            <!--<p class="author">Author</p>-->
        </div>
        <!--<div class="title-right title d-flex flex-row-reverse">
            <img v-if="titleImg" class="d-flex title-img" v-bind:src="require('@/assets/'+ titleImg)">
        </div>-->
    </div>
    <div v-for="(block,index) in content" v-bind:key="block.id" v-bind:class="[block.type == 'scroll' ? 'scroll-container': block.type == 'start' ? 'row start-row':'row scroll-row']" v-bind:id="[index == (content.length - 1) ? 'last' : index]">
        <div v-if="block.center" v-bind:class="[block.full ? 'half-center':'center']" v-bind:id="[block.id ? block.id : 'default-block']">
            <div class="block d-flex align-self-center">
                <p v-if="block.center.body" v-html="block.center.body"></p>
                <img v-if="block.center.img" class="story-img" v-bind:src="require('@/assets/'+ block.center.img)">
                <div v-if="block.center.map" v-bind:class="[titleType == 'scroll' ? 'map-container':'network-container']" >
                    <LeafletMap v-if="block.center.map" v-bind:map="block.center.map" v-bind:color="color"></LeafletMap>
                </div>
                <SideBySide v-if="block.center.sideLeft" v-bind:left="block.center.sideLeft" v-bind:right="block.center.sideRight"></SideBySide>
            </div>
        </div>
        <div v-if="block.left" class="left d-flex">
            <div class="block d-flex align-self-center">
                <p v-if="block.left.body" v-html="block.left.body"></p>
                <LeafletMap v-if="block.left.map" class="d-flex align-self-center" v-bind:map="block.left.map" v-bind:color="color"></LeafletMap>
                <img v-if="block.left.img"  class="d-flex align-self-center story-img"  v-bind:src="require('@/assets/'+ block.left.img)">
            </div>
        </div>
        <div v-if="block.right" class="right-inline d-flex" v-bind:id="[block.id ? block.id : 'default-block']">
            <div class="block d-flex align-self-center">
                <p v-if="block.right.body" v-html="block.right.body"></p>
                <LeafletMap v-if="block.right.map" class="d-flex align-self-center" v-bind:map="block.right.map" v-bind:color="color"></LeafletMap>
                <img v-if="block.right.img" class="d-flex align-self-center story-img" v-bind:src="require('@/assets/'+ block.right.img)">
            </div>
        </div>
        <div v-if="block.background" v-bind:id="[block.id ? block.id : 'default-block']" class="background-item" v-bind:style="(block.background.background) ?'background-color:'+ block.background.background:'background-color:rgba(0,0,0,0)'" >
            <div class="row scroll-row">
                <img v-if="block.background.img" class="vert-center-page" v-bind:src="getURL(block.background.img)">
                <div v-if="block.background.center" class="full-center">
                    <LeafletMap v-if="block.background.center.map" v-bind:map="block.background.center.map" v-bind:color="color"></LeafletMap>
                    <SideBySide v-if="block.background.center.sideLeft" v-bind:left="block.background.center.sideLeft" v-bind:right="block.background.center.sideRight"></SideBySide>
                    <img v-if="block.background.center.img" class="d-flex align-self-center vert-center-page" v-bind:src="require('@/assets/'+ block.background.center.img)" v-bind:style="(block.background.center.fit) ? 'object-fit:cover':'object-fit:contain'">
                </div>
                <div v-if="block.background.left" class="left d-flex">
                    <LeafletMap v-if="block.background.left.map" v-bind:map="block.background.left.map" v-bind:color="color"></LeafletMap>
                    <SideBySide v-if="block.background.left.sideLeft" v-bind:left="block.background.left.sideLeft" v-bind:right="block.background.left.sideRight"></SideBySide>
                    <img v-if="block.background.left.img"  class="d-flex align-self-center vert-center-page"  v-bind:src="require('@/assets/'+ block.background.left.img)">
                </div>
                <div v-if="block.background.right" class="right d-flex">
                    <LeafletMap v-if="block.background.right.map" v-bind:map="block.background.right.map" v-bind:color="color"></LeafletMap>
                    <SideBySide v-if="block.background.right.sideLeft" v-bind:left="block.background.right.sideLeft" v-bind:right="block.background.right.sideRight"></SideBySide>
                    <img v-if="block.background.right.img" class="d-flex align-self-center vert-center-page" v-bind:src="require('@/assets/'+ block.background.right.img)">
                </div>
            </div>
        </div>
        <div v-if="block.foreground" class="foreground-item" v-bind:id="[block.id ? block.id : 'default-block']">
            <div v-for="fblock in block.foreground.blocks" v-bind:key="fblock.id" class="row scroll-row">
                <div v-if="fblock.center" v-bind:class="(fblock.center.darkBackground) ? 'text-background-dark center': (fblock.center.lightBackground) ?'text-background-light center': 'center'">
                    <p v-if="fblock.center.body" v-html="fblock.center.body"></p>
                    <img v-if="fblock.center.img" class="story-img" v-bind:src="require('@/assets/'+ fblock.center.img)">
                    <p v-if="fblock.center.caption" class="caption" v-html="fblock.center.caption"></p>
                </div>
                <div v-if="fblock.left" v-bind:class="(fblock.left.darkBackground) ?'text-background-dark left': (fblock.left.lightBackground) ?'text-background-light left': 'left'">
                    <p v-if="fblock.left.body" v-html="fblock.left.body"></p>
                    <img v-if="fblock.left.img"  class="story-img"  v-bind:src="require('@/assets/'+ fblock.left.img)">
                    <p v-if="fblock.left.caption" class="caption" v-html="fblock.left.caption"></p>
                </div>
                <div v-if="fblock.right" v-bind:class="(fblock.right.darkBackground) ?'text-background-dark right': (fblock.right.lightBackground) ?'text-background-light right':'right'">
                    <p v-if="fblock.right.body" v-html="fblock.right.body"></p>
                    <img v-if="fblock.right.img" class="story-img" v-bind:src="require('@/assets/'+ fblock.right.img)">
                    <p v-if="fblock.right.caption" class="caption" v-html="fblock.right.caption"></p>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>

import LeafletMap from './LeafletMap.vue'
import SideBySide from './SideBySide.vue'

export default {
  name: 'ScrollMap',
  components: {
     LeafletMap,
     SideBySide
  },
  props:{
    title:String,
    titleImg:String,
    titleType:String,
    content:Array,
    color:String,
    background:String
  },
  created(){
    let self = this;
    window.addEventListener('resize',function(){
        self.resizeBackround();
    })
  },
  mounted(){
    this.setColor();
    this.resizeBackround();
  },
  updated(){
    this.setColor();
    this.resizeBackround();
  },
  methods:{
    setColor(){
        let self = this;
        document.querySelectorAll("b, hr, .network-link").forEach(function(elem){
            elem.style.color = self.color;
        })
    },
    resizeBackround(){
        var width = document.documentElement.clientWidth;

        document.querySelectorAll('.container').forEach(div =>{
            div.width = width + 'px !important';
        });
    }
  }

}
</script>

<style>
    /*content container*/
    .scroll-container{
        display:block;
        padding-bottom:10%;
    }
    .background-dark{
        background-color:black;
        color:white;
    }
    .background-light{
        background-color:white;
    }
    .background-light p {
        position:relative;
    }
    /*background/foreground*/
    .background-item{
        width:100%;
        height:100vh;
        z-index:0;
        position:sticky;
        display:block;
        top:0;
    }
    .foreground-item{
        position:relative;
        padding-bottom:50px;
        pointer-events:none;
    }

    /*positioning*/
    .center, .center-wide{
        text-align:center;
    }
    .full-width{
        width:100%;
    }
    .full-center{
        height:100vh;
    }
    .full-center > img{
        height:100%;
    }
    .half-center > .block > .map-container{
        width:100%;
    }

    /*title*/
    .title-row{
        margin-bottom:25%;
        padding-right:0 !important;
        padding-left:0 !important;
    }
    .title{
        height:100vh;   
        margin-left:0 !important;
    }

    .network-title-row{
        margin-bottom:50px;
    }

    .title h1{
        font-size:75px;
        color:white;
        text-align:right;
        z-index:100;
    }
    .network-title h1{
        font-size:75px;
        color:black;
        text-align:center;
        z-index:100;
        margin-top:10%;
    }
    .title-img{
        object-fit:cover;        
    }

    /*image content*/
    .story-img{
        display:block;
        margin:auto;
        width:100%;
    }
    .vert-center-page{
        width:100%;
    }
    .background-item .left, .background-item .right{
        height:100vh;
    }
    .foreground-item .left, .foreground-item .right{
        height:40vh;
    }
    .scroll-row, .start-row{
        padding-right: var(--bs-gutter-x,.75rem);
        padding-left: var(--bs-gutter-x,.75rem);
    }
    .start-row{
        margin-bottom:15%;
    }
    .scroll-row{
        margin-bottom:10%;
    }
    .no-margin{
        margin-bottom:0;
    }
    .lg-margin{
        margin-bottom:50%;
    }
    .sm-margin{
        margin-bottom:20%;
    }

    /*block styles*/
    .rounded{
        border-radius:10%;
    }
    .background-white{
        background-color:white;
        padding:20px;
    }
    .background-transparent{
        background-color:rgba(255,255,255,0.8);
        padding:20px;
    }

    /*final block in a page*/
    #last{
        margin-bottom:0 !important;
        padding-bottom:25%;
    }

    /*text styling*/
    .text-background-light > p{
        background:rgba(255,255,255,0.8);
        padding:10px;
    }
    .text-background-dark > p{
        background:rgba(0,0,0,0.7);
        color:white;
        padding:10px;
    }
    .caption{
        font-size:12px;
    }
    .network-link{
        font-weight:bold;
        pointer-events:visible !important;
    }

    /*interactions*/
    .no-event{
        pointer-events:none;
    }
    .left, .right, .center{
        text-align:left;
    }

    /*line break*/
    hr{
        height:3px !important;
        opacity: 1 !important;
    }

    /*map containers*/
    .map-container{
        height:50vh;
    }
    .network-container{
        height:25vh;
        width:100%;
    }   

    @media screen and (min-width: 1200px) {
        .center{
            flex: 0 0 auto;
            margin-left:25%;
            width:50%;
        }
        .left{
            flex: 0 0 auto;
            margin-left: 8.33333333%;
            width: 41.66666667%;
        }
        .right{
            flex: 0 0 auto;
            margin-left:50%;
            width: 41.66666667%;
        }
        .right-inline{
            width: 41.66666667%;
        }

        /*title placement*/
        .title-left, .title-right{
            flex: 0 0 auto;
            width: 50%;
        }
        }
        @media screen and (min-width: 720px) and (max-width: 1199px) {
        .center{
            flex: 0 0 auto;
            margin-left: 16.66666667%;
            width: 66.66666667%;
        }
        .left{
            flex: 0 0 auto;
            width: 50%;
        }
        .right{
            flex: 0 0 auto;
            margin-left:50%;
            width: 50%;
        }
        .right-inline{
            flex: 0 0 auto;
            width: 50%;
        }
        /*title placement*/
        .title-left, .title-right{
            flex: 0 0 auto;
            width: 50%;
        }
    }
    @media screen and (min-width: 540px) and (max-width: 719px) {
        .center{
            flex: 0 0 auto;
            margin-left: 8.33333333%;
            width: 83.333333333%;
        }
        .left{
            flex: 0 0 auto;
            width: 50%;
        }
        .right{
            flex: 0 0 auto;
            margin-left:50%;
            width: 50%;
        }
        .right-inline{
            flex: 0 0 auto;
            width: 50%;
        }
        /*title placement*/
        .title-left, .title-right{
            flex: 0 0 auto;
            width: 50%;
        }
    }
    @media screen and (max-width: 539px) {
        .center{
            width: 100%;
        }
        .left{
            width: 100%;
        }
        .right{
            width: 100%;
        }
        .right-inline{
            width: 100%;
        }
        /*title placement*/
        .title-left, .title-right{
            width: 100%;
        }
        p{
            background:rgba(255,255,255,0.8);
            padding:10px;
        }
        .title h1{
            text-align:center;
        }
    }
</style>
